// src/Components/AdminPanelComponents/Footer/AdminFooter.jsx
import "./AdminFooter.css";

const AdminFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="admin-footer">
      <p className="footer-text">
        © {year} University of Ghana Alumni Association Liberia. All Rights Reserved.
      </p>
      <p className="developer-credit">
        Powered by: <span>techbyodumgya@gmail.com</span>
      </p>
    </footer>
  );
};

export default AdminFooter;
